import { Game } from 'chessboard/model/game/types';

/**
 * Gets the color as a word, e.g. 'black', 'white'.
 */
export function getColorAsWord(color: Game.ColorsAsNumbers): Game.ColorsAsWords {
  return color === Game.ColorsAsNumbers.Black ? Game.ColorsAsWords.Black : Game.ColorsAsWords.White;
}
